"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTemp = void 0;
const kelvinToUnit_1 = require("./kelvinToUnit");
const temperatureToKelvin_1 = require("./temperatureToKelvin");
const convertTemp = (value, from, to) => {
    value = value === null ? NaN : value;
    if (!to && to !== 0) {
        return value;
    }
    return kelvinToUnit_1.kelvinToUnit(temperatureToKelvin_1.temperatureToKelvin(value, from), to);
};
exports.convertTemp = convertTemp;
//# sourceMappingURL=convertTemp.js.map